import type { SuperAdminsAwareInterface } from "shared-ui/types/integration-users-store.ts";

export const WordpressIntegrationStoreInjectKey = Symbol(
  "wordpress-integration-store",
);

export interface WordpressIntegrationStore extends SuperAdminsAwareInterface {
  siteUrl: string | null;
  fetchSiteUrl(): Promise<string>;
}
